import {
  AdTargetingType,
  AdvertisementTypeEnum,
  ArticleAdTargetKeys,
  PageAdTargetValue,
} from "@app/types/Ads.d";
import Advertisement from "@components/Elements/Advertisement/Advertisement";
import { GoogleAdsSlotFactory } from "@components/Elements/Advertisement/helpers";
import { pubPageAdTargeting } from "@config/ads";
import { IS_PLAYWRIGHT_TEST } from "@helper/getEnvVariables";
import { twMerge } from "tailwind-merge";

import {
  SvgAdsImu1,
  SvgAdsImu2,
  SvgAdsImu3,
  SvgAdsMidarticleSpecial,
} from "./AdsPlacehoderForE2ETest";

type AdsImuProps = {
  uniqueSectionName?: string;
  rootClassName?: string;
  pageAdTargetType?: PageAdTargetValue;
  isArticlePage?: boolean;
  gsChannels?: string[];
  articleSlotTarget?: AdTargetingType<ArticleAdTargetKeys, string>[];
  index?: number;
};

/**
 * BHBasePage
 * Description: The base page component for all BH pages
 * @name - name of section or page
 */

export function AdsImu1({
  uniqueSectionName,
  rootClassName,
  pageAdTargetType,
  isArticlePage = false,
  gsChannels,
  articleSlotTarget,
}: AdsImuProps) {
  const PubPageAdTarget =
    pageAdTargetType &&
    (pubPageAdTargeting[pageAdTargetType] as AdTargetingType<
      string,
      PageAdTargetValue
    >);
  return isArticlePage && gsChannels?.length == 0 ? (
    <></>
  ) : (
    <>
      {IS_PLAYWRIGHT_TEST === "true" ? (
        <div className="flex justify-center py-sm">
          <SvgAdsImu1 />
        </div>
      ) : (
        <Advertisement
          rootClassName={twMerge("block text-center", rootClassName)}
          adUnitProps={{
            type: AdvertisementTypeEnum.IMU1,
            slot: GoogleAdsSlotFactory.imu1(uniqueSectionName),
            ...(PubPageAdTarget && { pubAdTargeting: [PubPageAdTarget] }),
            gsChannels,
            articleSlotTarget,
            innerAdUnitClass: "flex justify-center",
          }}
        />
      )}
    </>
  );
}
export function AdsImu2({
  uniqueSectionName,
  pageAdTargetType,
  isArticlePage = false,
  gsChannels,
  articleSlotTarget,
  index,
}: AdsImuProps) {
  const PubPageAdTarget =
    pageAdTargetType &&
    (pubPageAdTargeting[pageAdTargetType] as AdTargetingType<
      string,
      PageAdTargetValue
    >);
  return isArticlePage && gsChannels?.length == 0 ? (
    <></>
  ) : (
    <div className="lg:h-[600px]">
      {IS_PLAYWRIGHT_TEST === "true" ? (
        <div className="flex justify-center lg:sticky lg:top-[130px]">
          <SvgAdsImu2 />
        </div>
      ) : (
        <Advertisement
          rootClassName={twMerge(
            "flex justify-center lg:sticky lg:top-[130px]",
            "!py-0",
          )}
          adUnitProps={{
            type: AdvertisementTypeEnum.IMU2,
            slot: GoogleAdsSlotFactory.imu2(uniqueSectionName),
            id: index ? `dfp-ad-imu2-${index}` : "dfp-ad-imu2",
            ...(PubPageAdTarget && { pubAdTargeting: [PubPageAdTarget] }),
            gsChannels,
            articleSlotTarget,
          }}
        />
      )}
    </div>
  );
}

export function AdsImu3({
  uniqueSectionName,
  rootClassName,
  pageAdTargetType,
  isArticlePage = false,
  gsChannels,
  articleSlotTarget,
}: AdsImuProps) {
  const PubPageAdTarget =
    pageAdTargetType &&
    (pubPageAdTargeting[pageAdTargetType] as AdTargetingType<
      string,
      PageAdTargetValue
    >);
  return isArticlePage && gsChannels?.length == 0 ? (
    <></>
  ) : (
    <>
      {IS_PLAYWRIGHT_TEST === "true" ? (
        <div className="flex justify-center py-sm">
          <SvgAdsImu3 />
        </div>
      ) : (
        <Advertisement
          rootClassName={twMerge("flex justify-center", rootClassName)}
          adUnitProps={{
            type: AdvertisementTypeEnum.IMU3,
            slot: GoogleAdsSlotFactory.imu3(uniqueSectionName),
            ...(PubPageAdTarget && { pubAdTargeting: [PubPageAdTarget] }),
            gsChannels,
            articleSlotTarget,
          }}
        />
      )}
    </>
  );
}

export function AdsMidArticle({
  uniqueSectionName,
  rootClassName,
  pageAdTargetType,
  isArticlePage = false,
  gsChannels,
  articleSlotTarget,
}: AdsImuProps) {
  const PubPageAdTarget =
    pageAdTargetType &&
    (pubPageAdTargeting[pageAdTargetType] as AdTargetingType<
      string,
      PageAdTargetValue
    >);
  return isArticlePage && gsChannels?.length == 0 ? (
    <></>
  ) : (
    <>
      {IS_PLAYWRIGHT_TEST === "true" ? (
        <div className="flex justify-center py-sm">
          <SvgAdsMidarticleSpecial />
        </div>
      ) : (
        <Advertisement
          rootClassName={twMerge("block text-center", rootClassName)}
          adUnitProps={{
            type: AdvertisementTypeEnum.MIDARTICLESPECIAL,
            slot: GoogleAdsSlotFactory.midarticlespecial(uniqueSectionName),
            ...(PubPageAdTarget && { pubAdTargeting: [PubPageAdTarget] }),
            gsChannels,
            articleSlotTarget,
            rootClassName: "",
            innerAdUnitClass: "flex justify-center",
          }}
        />
      )}
    </>
  );
}
